import { Paper, Typography, Divider, TableContainer, Table, TableBody, TableRow, TableCell, TableHead, IconButton, Collapse, Box } from '@material-ui/core'
import { IDocumentEvent } from 'types'
import moment from 'moment'
import 'moment/locale/es'
import React from 'react'
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons'

moment.locale("es")

interface Props {
    events: IDocumentEvent[]
}

const headerCellStyle = { fontSize: "0.75em", fontWeight: 600, letterSpacing: 0.2 }
const bodyCellStyle = { fontSize: "0.8em", letterSpacing: 0.2 }

const DocumentEvents = (props: Props) => {
    const { events } = props

    const automaticHistoryTypes = new Set([
        116, 125, 126, 127, 128, 129, 130, 131, 132
    ]);

    // Estado para controlar qué filas están abiertas
    const [openRows, setOpenRows] = React.useState<{ [key: number]: boolean }>({});

    const toggleRow = (index: number) => {
        setOpenRows(prev => ({ ...prev, [index]: !prev[index] }));
    }

    return (
        <div className="px-8 w-full">
            <Paper variant="outlined" className="mt-3 w-full" elevation={1}>
                <div className="py-3 px-4 flex w-full items-center">
                    <Typography style={{ fontWeight: 600, letterSpacing: 0.5, color: "#b1b1b1" }} variant="caption">
                        {"EVENTOS"}
                    </Typography>
                </div>
                <Divider />
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell style={headerCellStyle} align="left">{""}</TableCell>
                                <TableCell style={headerCellStyle} align="left">{"Evento"}</TableCell>
                                <TableCell style={headerCellStyle} align="left">{"Descripción"}</TableCell>
                                <TableCell style={headerCellStyle} align="left">{"Usuario"}</TableCell>
                                <TableCell style={headerCellStyle} align="left">{"Fecha"}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {events.map((event, index) => {
                                const hasAdicional = event.adicional && event.adicional.trim() !== "";

                                return (
                                    <React.Fragment key={index}>
                                        <TableRow>
                                            <TableCell style={bodyCellStyle} align="left">
                                                {hasAdicional ? (
                                                    <IconButton size="small" onClick={() => toggleRow(index)}>
                                                        {openRows[index] ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                                    </IconButton>
                                                ) : null}
                                            </TableCell>
                                            <TableCell style={bodyCellStyle} align="left">{event.historyName}</TableCell>
                                            <TableCell style={bodyCellStyle} align="left">{event.historyDescription}</TableCell>
                                            <TableCell style={bodyCellStyle} align="left">
                                                {automaticHistoryTypes.has(event.historyTypeId)
                                                    ? "Automático"
                                                    : event.userName}
                                            </TableCell>
                                            <TableCell style={bodyCellStyle} align="left">{moment(event.inserted).format('DD-MM-YYYY')}</TableCell>
                                        </TableRow>

                                        {hasAdicional && (
                                            <TableRow>
                                                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5}>
                                                    <Collapse in={!!openRows[index]} timeout="auto" unmountOnExit>
                                                        <Box margin={1}>
                                                            <Typography variant="body2" color="textSecondary">
                                                                {event.adicional}
                                                            </Typography>
                                                        </Box>
                                                    </Collapse>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </div>
    )
}

export default DocumentEvents
